import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config";
import styles from "./PagePreview.module.css";

// The new business's real booking page, live, with the owner preview bar
// (switch designs + colors, apply) — so a new owner sees what clients will
// see and picks a design right away. It's a look-only demo (taps on the page
// say so; the booking flow can be walked through without booking).
//
// `src` tags where it was opened (onboarding | chat). `color` (optional) is
// pushed into the page so a color picked outside the frame shows instantly;
// `onApplied({layout, color})` fires when the owner applies a design inside it;
// bump `reloadKey` to reload the page (e.g. after a new cover was uploaded).
const PagePreview = ({ src = "onboarding", compact = false, color, onApplied, onEdit, reloadKey = 0, title, subtitle }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const frameRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      setFailed(true);
      return;
    }
    axios
      .get(`${BASE_URL}/business-layouts/my-preview?src=${src}`, { headers: { Authorization: token } })
      .then((res) => (res.data?.url ? setUrl(res.data.url) : setFailed(true)))
      .catch(() => setFailed(true));
  }, [src]);

  const pushColor = () => {
    if (!color) return;
    frameRef.current?.contentWindow?.postMessage({ type: "tor-preview-color", color }, "*");
  };
  useEffect(pushColor, [color]);

  useEffect(() => {
    if (!onApplied && !onEdit) return undefined;
    const onMessage = (e) => {
      if (e.source !== frameRef.current?.contentWindow) return;
      if (e.data?.type === "tor-layout-applied" && onApplied) onApplied({ layout: e.data.layout, color: e.data.color });
      // A part of the page was tapped in edit mode — open its editor here
      if (e.data?.type === "tor-edit" && onEdit) onEdit(String(e.data.field || ""));
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [onApplied, onEdit]);

  if (failed) return null;

  return (
    <section className={`${styles.wrap} ${compact ? styles.compact : ""}`} dir="rtl">
      <h3 className={styles.title}>{title || "ככה הלקוחות שלכם יראו את העסק"}</h3>
      <p className={styles.sub}>
        {subtitle || "נסו את העיצובים החדשים ו-9 צבעים. בוחרים, לוחצים ״החלת העיצוב״ וזה באוויר"}
      </p>
      <div className={styles.phone}>
        {url ? (
          <iframe
            key={reloadKey}
            ref={frameRef}
            className={styles.frame}
            src={url}
            title="תצוגה מקדימה של העמוד שלכם"
            onLoad={() => setTimeout(pushColor, 1500)}
          />
        ) : (
          <div className={styles.skeleton} />
        )}
      </div>
      {url && (
        <a className={styles.fullBtn} href={url} target="_blank" rel="noreferrer">
          פתיחה במסך מלא
        </a>
      )}
    </section>
  );
};

export default PagePreview;
